import React, { useEffect, useState } from 'react';
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);
  useEffect(() => {
    const DURATION = 2 * 60 * 60;
    const storedEndTime = sessionStorage.getItem('bioclock_sale_end');
    let endTime: number;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
    } else {
      endTime = Date.now() + DURATION * 1000;
      sessionStorage.setItem('bioclock_sale_end', endTime.toString());
    }
    const calc = () => Math.max(0, Math.floor((endTime - Date.now()) / 1000));
    setTimeLeft(calc());
    const timer = setInterval(() => {
      const remaining = calc();
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  if (timeLeft === null) return null;
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 w-full bg-amber z-[60] text-center py-1.5 px-4" data-id="element-12">
      <p className="text-black font-bold text-xs md:text-sm tracking-wide" data-id="element-13">
        ⚠️ FLASH SALE: 85% OFF The 2025 BioClock Protocol. Offer ends in:{' '}
        <span className="font-mono inline-block min-w-[5.5ch]" data-id="element-14">
          {timeLeft === 0 ? 'EXPIRED' : `${pad(h)}:${pad(m)}:${pad(s)}`}
        </span>
      </p>
    </div>;
}